export default __webpack_public_path__ + "static/media/project-siput.398e80e3.png";